import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function HeroAnimated() {
  return (
    <section className="hero-grid relative overflow-hidden">
      <span className="hero-orb left-[8%] top-28 h-32 w-32 bg-[rgba(182,84,47,0.16)]" />
      <span className="hero-orb bottom-20 right-[10%] h-40 w-40 bg-[rgba(31,108,99,0.16)]" />

      <div className="section-shell flex min-h-[calc(100vh-88px)] items-center px-6 py-16">
        <div className="grid items-center gap-12 lg:grid-cols-[1.2fr_0.8fr]">
          <div>
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="eyebrow"
            >
              Inclusive AI Interface
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.1 }}
              className="mt-6 max-w-4xl text-5xl font-bold leading-[0.96] text-stone-900 md:text-7xl"
            >
              Translate sign language into conversation-ready text in real time.
            </motion.h1>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.45, duration: 0.9 }}
              className="mt-6 max-w-2xl text-lg leading-8 text-stone-600 md:text-xl"
            >
              SignAI combines live hand tracking, computer vision, and a focused
              recognition pipeline to make spoken and signed communication feel
              faster and more natural.
            </motion.p>

            <motion.div
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.75, duration: 0.6 }}
              className="mt-10 flex flex-wrap items-center gap-4"
            >
              <Link to="/live" className="cta-primary">
                Try Live Detection
              </Link>

              <Link
                to="/how"
                className="rounded-full border border-[rgba(107,79,47,0.18)] px-6 py-4 font-semibold text-stone-700 transition hover:bg-white/60"
              >
                See the Pipeline
              </Link>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.35, duration: 0.8 }}
            className="content-card rounded-[2rem] p-6 md:p-8"
          >
            <div className="grid gap-4 md:grid-cols-2">
              <div className="info-panel rounded-[1.5rem] p-5">
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-stone-500">
                  Input
                </p>
                <h3 className="mt-3 text-2xl text-stone-900">
                  Live gesture stream
                </h3>
                <p className="mt-3 text-base leading-7 text-stone-600">
                  Webcam capture tuned for recognition, feedback, and fast
                  iteration.
                </p>
              </div>

              <div className="info-panel rounded-[1.5rem] p-5">
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-stone-500">
                  Output
                </p>
                <h3 className="mt-3 text-2xl text-stone-900">Readable text</h3>
                <p className="mt-3 text-base leading-7 text-stone-600">
                  Predicted letters and sentence assembly designed for
                  accessible communication.
                </p>
              </div>
            </div>

            <div className="mt-6 rounded-[1.5rem] border border-[rgba(107,79,47,0.14)] bg-[rgba(255,255,255,0.72)] p-6">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-stone-500">
                Why it matters
              </p>
              <p className="mt-4 text-lg leading-8 text-stone-700">
                Gesture recognition is only useful when the interface stays
                calm, legible, and responsive. The product surface should
                support that, not distract from it.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
